module.exports = __webpack_public_path__ + "img/boa.9acd0f11.jpg";